import { useEffect } from "react"
import { useCookies } from "react-cookie"
import { useLocation } from "react-router-dom"

const excludedRoutes = [
  "/login"
]

export default function LastLocationCookie() {
  const cookieName = "last_route"
  const [, setCookie] = useCookies([cookieName])
  const { pathname } = useLocation()

  useEffect(() => {
    if (pathname && !_.includes(excludedRoutes, pathname)) {
      setCookie(cookieName, pathname, { path: "/" })
    }
  }, [pathname, setCookie])

  return null
}
